import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';

import AutoCompleteBase from '../helpers/AutoComplete';
import isFunction from '../../utils/isFunction';

const AutoCompleteComponent = ({ info, onGetSuggestion, onGetNextSuggestion, onChange, inputProps }) => {
  const handleUpdateSuggestions = update => {
    onChange({
      formName: inputProps.get('formName'),
      formData: update,
    });
  };

  const handleSuggestionSelected = (event, { suggestion }) => {
    const render = inputProps.get('renderField');

    onChange({
      formName: inputProps.get('formName'),
      formData: {
        text: render && isFunction(render) ? render(suggestion) : suggestion[inputProps.get('renderField')],
        suggestions: [],
        selected: suggestion,
      },
    });
  };

  const handleRenderSuggestion = suggestion => {
    const render = inputProps.get('renderField');

    if (render && isFunction(render)) {
      return <div>{render(suggestion)}</div>;
    }

    return <div>{suggestion[render]}</div>;
  };

  const handleGetSuggestionValue = suggestion => suggestion.id;

  const suggestions = info.get('suggestions');
  const text = info.get('text');

  const loading = info.get('loading', null);

  const suggestionProps = {
    inputProps: {
      label: inputProps.get('label'),
      disabled: inputProps.get('disabled', false),
      placeholder: inputProps.get('placeholder'),
      autoComplete: 'off',
      className: 'form-control',
    },
    formGroupClass: ' ',
    suggestions,
    loading,
    onUpdateSuggestions: handleUpdateSuggestions,
    getSuggestion: onGetSuggestion,
    getNextSuggestion: onGetNextSuggestion,
    renderSuggestion: handleRenderSuggestion,
    onSuggestionSelected: handleSuggestionSelected,
    getSuggestionValue: handleGetSuggestionValue,
    suggestIfEmpty: true,
    text,
  };

  return <AutoCompleteBase {...suggestionProps} />;
};

AutoCompleteComponent.propTypes = {
  info: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  onGetNextSuggestion: PropTypes.func,
  onGetSuggestion: PropTypes.func.isRequired,
};

/** Auto complete component. */
export const AutoComplete = memo(AutoCompleteComponent);
